import { render, staticRenderFns } from "./FullView2021Micro.vue?vue&type=template&id=a522ae18"
import script from "./FullView2021Micro.vue?vue&type=script&lang=js"
export * from "./FullView2021Micro.vue?vue&type=script&lang=js"
import style0 from "./FullView2021Micro.vue?vue&type=style&index=0&id=a522ae18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports